import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ServicesHero from "./components/ServicesHero";
import ServicesIntro from "./components/ServicesIntro";
import ServicesGrid from "./components/ServicesGrid";
import HowWeWork from "./components/HowWeWork";
import ServicesWhatsApp from "./components/ServicesWhatsApp";

export default function ServicesPage() {
  useEffect(() => {
    document.title =
      "Our Services | Real Estate Development & Villa Plots Karnataka | Urban Infra";

    const setMeta = (name: string, content: string, prop = false) => {
      const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        if (prop) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Explore Urban Infra's full range of real estate services across Karnataka — layout development, villa plots, gated community planning, and property consultation. UrbanInfraProjects.in."
    );
    setMeta("keywords", "real estate services Karnataka, villa plot development, layout planning, gated community developer, UrbanInfraProjects.in");
    setMeta("og:title", "Our Services | Villa Plots & Real Estate Karnataka | Urban Infra", true);
    setMeta("og:description", "Layout development, villa plots, and property consultation across Karnataka by Urban Infra.", true);
    setMeta("og:url", `${import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in"}/services`, true);
    setMeta("og:site_name", "Urban Infra", true);
    setMeta("og:type", "website", true);

    // Schema.org JSON-LD — Service
    const schemaId = "schema-services";
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = schemaId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Real Estate Development Services",
      provider: {
        "@type": "Organization",
        name: "Urban Infra",
        url: siteUrl,
        telephone: "+919945124133",
      },
      serviceType: "Real Estate Development",
      areaServed: {
        "@type": "State",
        name: "Karnataka",
      },
      description:
        "Urban Infra provides layout development, villa plot sales, site selection, and property consultation services across Karnataka.",
    });

    window.scrollTo(0, 0);
    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <SiteHeader />
      <main>
      <ServicesHero />
      <ServicesIntro />
      <ServicesGrid />
      <HowWeWork />
      <ServicesWhatsApp />
      </main>
      <SiteFooter />
    </>
  );
}
